<template>
  <v-container fluid pa-0>
    <v-layout row wrap>
      <v-flex xs12 sm12 md12  lg12 xl12 mx-4>
        <data-table
          :url="`/customers`"
          content="customersList"
          :filters="filters"
          :dashboard="true"
          :limit="6"
          >
          <template slot="title">
            <v-layout row wrap>
              <v-flex xs6>
                <p class="headline mt-2">Clientes</p>
              </v-flex>
              <v-flex xs6 class="text-xs-right">
                <v-btn color="k-orange-linear" @click="showCreteClientModal">
                  Agregar cliente
                </v-btn>                
              </v-flex>
            </v-layout>
          </template>
          <template slot="navigation-bar">
            <v-flex md6 pr-2>
              <v-text-field solo label="Busqueda" @focus="showSearchCustomer = true" color="grey" append-icon="fas fa-search" v-model="search"></v-text-field>
            </v-flex>
            <v-flex md3 pr-2>
              <v-select
                :items="status"
                v-model="filters.status"
                item-text="status"
                item-value="id"
                label="Estados"
                color="black"
                solo
              ></v-select>
            </v-flex>
            <v-flex md3>
              <v-select
                :items="listSubStatuses"
                v-model="filters.sub_status"
                item-text="name"
                item-value="id"
                label="Sub-estado"
                color="black"
                solo
              ></v-select>
            </v-flex>
          </template>
        </data-table>
        <v-dialog
          v-model="dialog"
          scrollable
          persistent
          :overlay="false"
          min-width="10px"
          max-width="600px"
        >
          <v-card>
            <v-toolbar flat class="k-orange-linear">
              <v-toolbar-title class="white--text pl-4 py-3">
                {{title}}
              </v-toolbar-title>
            </v-toolbar>
            <v-card-text>
              <v-list two-line>
                <template v-for="(item, i) in phones">
                  <v-divider v-if="i > 0"></v-divider>
                  <v-list-tile>
                    <v-list-tile-content>
                      <v-list-tile-title>
                        {{title === 'Telefonos' ? `${item.phone}` : `${item.email}`}}
                      </v-list-tile-title>
                      <v-list-tile-sub-title>{{item.type}}</v-list-tile-sub-title>
                    </v-list-tile-content>
                    <v-list-tile-content>
                      <div class="text-xs-right w-100">
                        <v-chip small :class="{'grey white--text':item.status === 'Por validar', 'k-orange-linear white--text f1em':item.status === 'Invalido', 'green white--text f1em':item.status === 'Valido'}">
                          <v-icon small class="white--text" v-if="item.status === 'Valido'">fas fa-check</v-icon>
                          <v-icon small class="white--text" v-else-if="item.status === 'Invalido'">fas fa-times</v-icon>
                          <v-icon small class="white--text" v-else>fas fa-exclamation-circle</v-icon>
                          &nbsp;&nbsp;
                          {{item.status}}
                        </v-chip>
                      </div>
                    </v-list-tile-content>
                  </v-list-tile>
                </template>
              </v-list>
            </v-card-text>
            <v-card-actions>
              <v-layout>
                <v-flex xs12 text-xs-right pr-4>
                  <v-btn flat color="black" @click="closeModal()">
                    CERRAR
                  </v-btn>
                </v-flex>
              </v-layout>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <search-customer 
          @selected="goToCustomer" 
          :show="showSearchCustomer"
          :searchOnCreate="true"
          @change-search="search = $event"
          @change-value="showSearchCustomer = $event">
        </search-customer>
        <create-customer-dialog :show="showCreate" @change="showCreate = $event">
        </create-customer-dialog>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import Vue from 'vue';
import { mapGetters } from 'vuex';
import EventBus from '@/event-bus';
import dataTable from '@/components/global/DataTable';
import customersList from '@/components/customer/CustomersList';
import SearchCustomer from './SearchCustomer';
import CreateCustomerDialog from './CreateCustomerDialog';

Vue.component('customersList', customersList);

export default {
  inject: ['$validator'],
  components: {
    dataTable,
    SearchCustomer,
    CreateCustomerDialog,
  },
  created() {
    this.$store.dispatch('GET_AGE_GROUPS');
    this.$store.dispatch('GET_STATES');
    this.$store.dispatch('GET_GENDERS');
    this.$store.dispatch('GET_ACCOUNT');
    this.$store.dispatch('GET_CUSTOMER_STATUSES');
    EventBus.$on('delete', (resp) => {
      if (resp) {
        EventBus.$emit('update');
      }
    });
    EventBus.$on('openModal', (resp, type) => {
      // eslint-disable-next-line
      type === 'email' ? this.title = 'Emails' : this.title = 'Telefonos';
      this.phones = resp;
      this.dialog = true;
    });
  },
  destroyed() {
    EventBus.$off('delete');
    EventBus.$off('openModal');
  },
  data() {
    return {
      showCreate: false,
      title: '',
      dialog: false,
      search: '',
      filters: {
        status: 0,
        sub_status: 0,
      },
      phones: [],
      showSearchCustomer: false,
    };
  },
  computed: {
    ...mapGetters([
      'customerStatuses',
      'subStatuses',
    ]),
    status() {
      const status = [{
        status: 'Todos',
        id: 0,
      }];
      status.push(...this.customerStatuses);
      return status;
    },
    listSubStatuses() {
      const status = [{
        name: 'Todos',
        id: 0,
      }];
      status.push(...this.subStatuses);
      return status;
    },
  },
  methods: {
    closeModal() {
      this.dialog = false;
    },
    goToCustomer({ customer }) {
      this.$router.push(`/customers/${customer.id}/show`);
    },
    showCreteClientModal() {
      this.showCreate = true;
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/customer/Index.vue